import Carousel1 from "./carousel (1).webp";
import Carousel2 from "./carousel (2).webp";
import Carousel3 from "./carousel (3).webp";

const carousel1images = [Carousel1, Carousel2, Carousel3];

export default carousel1images;
